import React, {useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {
    Box,
    Typography,
    TextField,
    Button,
    InputAdornment,
    IconButton,
    Checkbox,
    FormControlLabel,
} from '@mui/material';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import {login} from '../../services/api';
import '../../styles/Login.css';
import backgroundImage from '../../assets/images/background.png';
import logo from '../../assets/images/itup_logo.png';
import termsOfUseText from '../../assets/TermsOfUse';

export default function Login() {
    const navigate = useNavigate();

    const isChrome = useMemo(() => {
        const ua = navigator.userAgent;
        console.log('User Agent:', ua);
        // verdadeiro só se for Chrome e NÃO Edge/Opera/Vivaldi/Brave
        return /Chrome\/\d+/.test(ua) && !/(Edg|OPR|Vivaldi|Brave)\//.test(ua);
    }, []);

    const [aliasAccess, setAliasAccess] = useState(
        localStorage.getItem('aliasAccess-fornecedor') || '',
    );
    const [rememberToken, setRememberToken] = useState(
        localStorage.getItem('rememberToken-fornecedor') === 'true',
    );
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [showTerms, setShowTerms] = useState(false);
    const [accepted, setAccepted] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const {data} = await login({aliasAccess, username, password, app_id: 4});
            localStorage.setItem('token-fornecedor', data.token);
            localStorage.setItem('projects-fornecedor', data.projects);

            const acceptedUsers = JSON.parse(
                localStorage.getItem('acceptedUsers-fornecedor') || '{}',
            );
            //Lui solicitou remoção dos termos de uso por hora. Para mostrar os termos, descomentar
            // if (acceptedUsers[username]) {
            navigate('/inicio');
            // } else {
            //     setShowTerms(true);
            // }
        } catch (err) {
            setError(
                err.response?.data?.error || 'Um erro ocorreu. Verifique a conexão com o Rest',
            );
            console.error(err);
        }
    };

    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    const confirmTerms = () => {
        if (accepted) {
            const acceptedUsers = JSON.parse(
                localStorage.getItem('acceptedUsers-fornecedor') || '{}',
            );
            acceptedUsers[username] = true;
            localStorage.setItem('acceptedUsers-fornecedor', JSON.stringify(acceptedUsers));
            setShowTerms(false);
            navigate('/inicio');
        }
    };

    const handleAliasChange = (e) => {
        const v = e.target.value;
        setAliasAccess(v);
        if (rememberToken) {
            localStorage.setItem('aliasAccess-fornecedor', v);
        } else {
            localStorage.removeItem('aliasAccess-fornecedor');
        }
    };

    return (
        <>
            {!isChrome && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: 'red',
                        color: 'white',
                        textAlign: 'center',
                        py: 1,
                        zIndex: 1400,
                        fontWeight: 'bold',
                    }}
                >
                    Navegador não homologado — Utilize o&nbsp;
                    <a
                        href="https://www.google.com/chrome/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{color: 'white', textDecoration: 'underline'}}
                    >
                        Chrome
                    </a>
                </Box>
            )}
            <Box
                className="login-page"
                sx={{
                    pt: !isChrome ? '48px' : 0,
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <Box className="login-box">
                    <img src={logo} alt="Rental Itup Logo" className="login-logo" />
                    <Typography className="login-title">
                        <span>Bem-vindo ao</span>
                        <span className="login-title-bold">&nbsp;Portal do Fornecedor!</span>
                    </Typography>

                    {error && <Typography className="login-error">{error}</Typography>}

                    <Box component="form" onSubmit={handleLogin} className="login-form">
                        {/* Token */}
                        <Box className="input-group" sx={{position: 'relative'}}>
                            <Typography className="input-label">Token</Typography>
                            <TextField
                                variant="outlined"
                                size="small"
                                value={aliasAccess}
                                onChange={handleAliasChange}
                                required
                                className="login-input"
                            />
                            {/* checkbox “manter token” */}
                            {/* checkbox “manter token” flutuando */}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={rememberToken}
                                        onChange={(e) => {
                                            setRememberToken(e.target.checked);
                                            if (e.target.checked) {
                                                localStorage.setItem(
                                                    'rememberToken-fornecedor',
                                                    'true',
                                                );
                                                localStorage.setItem(
                                                    'aliasAccess-fornecedor',
                                                    aliasAccess,
                                                );
                                            } else {
                                                localStorage.removeItem('rememberToken-fornecedor');
                                                localStorage.removeItem('aliasAccess-fornecedor');
                                            }
                                        }}
                                    />
                                }
                                label="Manter token"
                                sx={{
                                    'position': 'absolute',
                                    'top': '100%',
                                    'right': 0,
                                    'mt': '0px',
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '0.75rem',
                                    },
                                }}
                            />
                        </Box>

                        {/* Usuário */}
                        <Box className="input-group">
                            <Typography className="input-label">Usuário</Typography>
                            <TextField
                                variant="outlined"
                                size="small"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                className="login-input"
                            />
                        </Box>

                        {/* Senha */}
                        <Box className="input-group">
                            <Typography className="input-label">Senha</Typography>
                            <TextField
                                variant="outlined"
                                size="small"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="login-input"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={handleTogglePassword}
                                                edge="end"
                                                size="small"
                                            >
                                                {showPassword ? (
                                                    <VisibilityOff fontSize="small" />
                                                ) : (
                                                    <Visibility fontSize="small" />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>

                        <Button type="submit" className="login-button" variant="contained">
                            Entrar
                        </Button>
                    </Box>
                </Box>

                {/* Modal de Termos de Uso */}
                {showTerms && (
                    <Box className="modal-overlay">
                        <Box className="modal-box">
                            <Box className="modal-header">
                                <Typography variant="h6">Termos de uso</Typography>
                                <IconButton
                                    className="close-btn"
                                    onClick={() => setShowTerms(false)}
                                    size="small"
                                >
                                    ×
                                </IconButton>
                            </Box>
                            <Box className="modal-body">
                                <Typography sx={{whiteSpace: 'pre-line', textAlign: 'justify'}}>
                                    {termsOfUseText}
                                </Typography>
                            </Box>
                            <Box className="modal-footer">
                                <Box className="terms-checkbox">
                                    <input
                                        type="checkbox"
                                        id="acceptTerms"
                                        checked={accepted}
                                        onChange={(e) => setAccepted(e.target.checked)}
                                    />
                                    <label htmlFor="acceptTerms">
                                        Declaro que aceito os termos de uso descritos
                                    </label>
                                </Box>
                                <Button
                                    className="accept-btn"
                                    variant="contained"
                                    onClick={confirmTerms}
                                    disabled={!accepted}
                                >
                                    Confirmar &amp; Prosseguir
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        </>
    );
}
